import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./JobBankSigndown.css";
import {
  doc,
  getDoc
} from 'firebase/firestore';

import {
  db
} from "../utils/firebase";

import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import { useAuth } from './AuthContext';
function JobBankSigndown() {
    const { balance, setBalance } = useContext(TokenContext);
      const { currentUser } = useAuth();
      useEffect(() => {
            let isMounted = true;
        
            const fetchTokens = async () => {
              if (!currentUser?.uid) return;
        
              const userRef = doc(db, "users", currentUser.uid);
        
              try {
                const userDoc = await getDoc(userRef);
        
                if (userDoc.exists() && isMounted) {
                  setBalance(userDoc.data().tokens ?? 0);
                }
              } catch (error) {
                console.error("Error fetching token count:", error);
              }
            };
        
            fetchTokens();
        
            return () => {
              isMounted = false;
            };
          }, [currentUser, setBalance]);
  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  return (

    <div className="JBSD-container">

      <div className="JBSD-card">

        <h1 className="JBSD-title">
          Community Job Bank
        </h1>

        <p className="JBSD-subtitle">
          Account Registration Temporarily Unavailable
        </p>

        <p className="JBSD-description">
          We are currently performing maintenance and
          system upgrades to improve the Community Job
          Bank experience.
        </p>

        <div className="JBSD-message-box">

          <h2>
            Sign-Ups Are Temporarily Closed
          </h2>

          <p>
            New account registrations are temporarily
            unavailable while we complete platform
            improvements.
          </p>

          <p>
            Existing users may continue to sign in and
            access their accounts normally.
          </p>

          <Link
            to="/jobbank"
            className="JBSD-home-link"
          >
            Return to Community Job Bank
          </Link>

        </div>

        <div className="JBSD-links">

          <button
            className="JBSD-link-button"
            onClick={() =>
              navigateTo("/jobbank/about")
            }
          >
            About Us
          </button>

          <button
            className="JBSD-link-button"
            onClick={() =>
              navigateTo("/jobbank/contact")
            }
          >
            Contact
          </button>

          <button
            className="JBSD-link-button"
            onClick={() =>
              navigateTo("/jobbank/help")
            }
          >
            Help
          </button>

          <button
            className="JBSD-link-button"
            onClick={() =>
              navigateTo("/jobbank/login")
            }
          >
            Sign In
          </button>

        </div>

      </div>
        {createPortal(
                <GlobalNavDrawer
                  hideCurrent
                  links={[
                    { to: "/purchase", label: `Tokens: ${balance}`},
                    { to: "/jobbank", label: "Job Bank Home"},
                    { to: "/voicebot", label: "iSpeakWell" },
                    { to: "/resumerevisor", label: "Resumes" },
                    { to: "/conversationpractice", label: "Convos" },
                    { to: "/interview-practice", label: "Interviews" },
                    { to: "/termsofservice", label: "Terms" },
                    { to: "/privacypolicy", label: "Privacy" },
                    { to: "/admin", label: "Admin" },
                    { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
                  ]}
                />,
                  document.body
              )}
    </div>

  );
}

export default JobBankSigndown;